export default __webpack_public_path__ + "static/media/Like_Active.e1d392f2.svg";